import { getFormDataFromObject } from "../shared/helpers/formDataHelper";
import { URL_BASE } from "./constants";
import { deleteRequest, get, handleErrors, post, put } from "./requests";
import { Store } from "../redux/store";

export async function getAllMarketingCampaigns(term = "", isActive = null) {
    let url = `${URL_BASE}/marketing-campaigns`;
    const queryParams = [];
  
    if (term) {
      queryParams.push(`search=${term}`);
    }
  
    if (isActive !== null) {
      queryParams.push(`isActive=${isActive}`);
    }
  
    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }
  
    const campaigns = await get(url);
    return campaigns.data;
  }

export async function getMarketingCampaignById(id) {
    const url = `${URL_BASE}/marketing-campaigns/${id}`;
    const response = await get(url);
    return response.data;
}

export async function createMarketingCampaign(name, companyName, description, banners, position, idCity) {
    const marketingCampaign = {
        Name: name,
        Description: description,
        CompanyName: companyName,
        Banners: banners,
        Position: position, 
        IdCity: idCity
    };
    const formData = getFormDataFromObject(marketingCampaign);
    await post(`${URL_BASE}/marketing-campaigns`, formData, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
}

export async function editMarketingCampaign(id, name, companyName, description, banners, position, idCity) {
    const marketingCampaign = {
        Name: name,
        Description: description,
        CompanyName: companyName,
        Banners: banners,
        Position: position,
        IdCity: idCity
    };
    const formData = getFormDataFromObject(marketingCampaign);
    await put(`${URL_BASE}/marketing-campaigns/${id}`, formData, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
}

export async function removeMarketingCampaign(id) {
    const url = `${URL_BASE}/marketing-campaigns/${id}`;
    const response = await deleteRequest(url);
    return response.data;
}

export async function changeStatus(id, newStatus) {  
    const token = Store.getState().authState.loggedUser;
    if (!Boolean(token)) {
      throw new Error('Token not available');
    }
    
    try {
      const response = await put(`${URL_BASE}/marketing-campaigns/${id}/status?isActive=${Boolean(newStatus)}`, null, { headers: { 'Authorization': `Bearer ${token}` } });
      return response.data;
    } catch (error) {
      const { status, data } = error;
      handleErrors(status, data);
      throw error;
    }
  }